import {createBaseOptions, fetchJson, METHOD_GET} from "../utils/SuperAgentFetch";
import {config} from "../config/Config";
import { notificationError } from "../utils/NotificationsHelper";

export const fetchIdentityToEntriesList = (callback) => {
    let res = null
        
    /** @type RequestOptions */
    let options = createBaseOptions();
    options.method = METHOD_GET;
    options.headers["Content-Type"] = "application/json";

    let r = fetchJson(`${config.url.API_URL}/identityToEntries/custom/items/withAssignedEntries`, options);
    r.then(json => {
        if (json._embedded && json._embedded.identityToEntries && json._embedded.identityToEntries.length > 0 ) {
             res = json._embedded.identityToEntries;
             callback(res);
        }
       
    }).catch(error => {
        if(error && error.response && error.response.response  && error.response.response.body){
            notificationError(error.response.response.body.error, error.response.response.body.error_description)
        }
        console.log(error);
        callback([]);
    });
};

